import { createAction } from '@reduxjs/toolkit';
import { SearchParams } from '../../../creativeHub/modules/search/model';

export const pagePathChanged = createAction<
  {
    page: string;
    match: any;
    location: any;
    // только для хаба
    hubSearchPageParams?: SearchParams;
  },
  'general/router/pagePathChanged'
>('general/router/pagePathChanged');
